import Store from './Store';

export default new Store('project');
